<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'BILLABLE-SERVICES'" [breadcrumb]="''" [count]="count"
    icon="fa-file-invoice-dollar">
</app-breadcrumb>
<div class="content-background">
    <div class="row">
        <div class="col-sm-12">
            <div class="inputWithIcon inputWithIcon-search float-right d-flex">
                <app-advanced-mode id="billableGridAdvancedSwitch" [storageKey]="'billable-list'"
                    (collapsibleToggle)="enableAdvanced=$event">
                </app-advanced-mode>
                <input #search kendoTextBox class="ml-4 button-search" placeholder="{{ 'SEARCH-NAME' | translate }}"
                    (keyup)="searchFieldChange(search.value)" title="{{ 'SEARCH-NAME' | translate }}" />
                <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
            </div>
        </div>
    </div>
    <div class="mt-3">
        <kendo-grid [data]="view.gridData" [loading]="view.loading" [navigable]="true"
            [pageable]="count > view.state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
            [pageSize]="view.state.take" [skip]="view.state.skip" [sortable]="true" [sort]="view.state.sort"
            [filterable]="enableAdvanced" [filter]="view.state.filter" [groupable]="enableAdvanced"
            [group]="view.groups" [selectable]="{ mode: 'single' }" [columnMenu]="enableAdvanced" [resizable]="true"
            [reorderable]="enableAdvanced" (groupChange)="groupChange($event)"
            (dataStateChange)="dataStateChange($event)">
            <kendo-grid-messages noRecords="{{ 'NO-BILLABLE-SERVICES' | translate }}">
            </kendo-grid-messages>
            <kendo-grid-column field="name" [width]="20" title="{{ 'NAME' | translate }}"></kendo-grid-column>
            <kendo-grid-column field="description" [width]="40" title="{{ 'DESCRIPTION' | translate }}">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span title="{{dataItem.description}}">{{dataItem.description | truncate: 100 }}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="feeSchedule.displayName" [width]="20" title="{{ 'FEE-SCHEDULE' | translate }}">
            </kendo-grid-column>
            <kendo-grid-column field="feeCategory.displayName" [width]="20" title="{{ 'FEE-CATEGORY' | translate }}">
            </kendo-grid-column>
            <kendo-grid-column field="accumulator.name" [width]="20" title="{{ 'ACCUMULATOR' | translate }}">
            </kendo-grid-column>
            <kendo-grid-column class="text-center" field="informationalOnly" [width]="10"
                title="{{ 'INFORMATIONAL-ONLY' | translate }}" filter="boolean">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <i *ngIf="dataItem.informationalOnly" class="fas fa-check"></i>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column class="text-center" field="manualAmount" [width]="10"
                title="{{ 'MANUAL-AMOUNT' | translate }}" filter="boolean">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <i *ngIf="dataItem.manualAmount" class="fas fa-check"></i>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column class="text-center" field="enabled" [width]="10" title="{{ 'ENABLED' | translate }}"
                filter="boolean">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <i *ngIf="dataItem.enabled" class="fas fa-check"></i>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="lastModifiedBy" [width]="25" title="{{ 'LAST-MODIFIED-BY' | translate }}">
            </kendo-grid-column>
            <kendo-grid-column field="lastModifiedOn" [width]="20" title="{{ 'LAST-MODIFIED-DATE' | translate }}"
                filter="date" format="{0:g}"></kendo-grid-column>
            <kendo-grid-command-column [width]="10" title="{{ 'ACTIONS' | translate }}" class="text-center">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <i class="fas fa-edit fa-lg" title="{{ 'EDIT' | translate }}" (click)="editHandler(dataItem['id'])">
                    </i>
                    &nbsp;
                    <i class="fas fa-trash-alt fa-lg" title="{{ 'DELETE' | translate }}"
                        (click)="deleteHandler(dataItem['id'])">
                    </i>
                </ng-template>
            </kendo-grid-command-column>
        </kendo-grid>
        <button kendoButton [primary]="false" type="button" class="float-right mt-3 mb-3 ml-3" (click)="addHandler()">
            {{'ADD' | translate}}<i class="far fa-plus"></i>
        </button>
        <button kendoButton appPreventClick (click)="importFromJson()"
            title="{{'IMPORT-BILLABLE-SERVICES-FROM-JSON' | translate}}" [disabled]="importing" [primary]="true"
            class="float-right mt-3 mb-3 ml-3">{{ 'IMPORT' | translate }}<i class="far fa-file-import"
                *ngIf="!importing"></i><i class="k-icon k-i-loading" *ngIf="importing"></i>
        </button>
        <button kendoButton [primary]="false" type="button" title="{{'EXPORT-BILLABLE-SERVICES-TO-JSON' | translate}}"
            class="float-right mt-3 mb-3 ml-3" (click)="exportToJson()">{{'EXPORT' | translate}}<i
                class="far fa-file-export"></i>
        </button>
    </div>
</div>

<!--Add/Edit form-->
<app-billable-edit [model]="editDataItem" [isNew]="isNew" (save)="saveChangesHandler($event)"
    (cancelling)="cancelChangesHandler()">
</app-billable-edit>

<!--Delete confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="deleteDialogOpened" (close)="close('deleteDialog')"
    [minWidth]="250" [width]="450">
    <p>{{ 'CONFIRM-DELETION' | translate }}</p>
    <p *ngIf="!billableServiceInUse"> {{billableServiceNotInUse}} </p>
    <span class="k-font-weight-bold">{{selectedBillable.name}}</span>
    <kendo-dialog-actions>
        <button kendoButton (click)="deleteAction(false)">{{ 'NO' | translate }}</button>
        <button appPreventClick kendoButton (click)="deleteAction(true)" [primary]="true">{{ 'YES' | translate
            }}</button>
    </kendo-dialog-actions>
</kendo-dialog>

<kendo-upload class="d-none" [autoUpload]="false" [multiple]="false" (select)="onFileImportChanged($event)">
</kendo-upload>